import { RootState } from 'app/reducer';
import Table, { TableCol } from 'modules/Layout/component/Table';
import Family from 'modules/Family/model/Family';
import React, { createRef, ReactNode } from 'react';
import { connect } from 'react-redux';
import {
  ROUTE_FAMILY_DETAILS,
  ROUTE_FAMILY_DETAILS_FORM
} from 'modules/Family/routes';
import { PartialSearchingProps, SortParams } from 'modules/Shared/type';
import {
  setFamilyListParamsAction,
  SetFamilyListParamsAction
} from 'modules/Family/action/List';
import { Dispatch } from 'redux';
import { getPathUrl } from 'modules/Shared/helper/api';
import ActionShow from 'modules/Layout/component/Action/Show';
import ActionUpdate from 'modules/Layout/component/Action/Update';
import DeleteFamilyModal, {
  DeleteFamilyModal as DeleteFamilyModalClass
} from 'modules/Family/component/Modal/Delete';
import ActionDelete from 'modules/Layout/component/Action/Delete';

export interface StateProps {
  families: Family[];
  sort: SortParams;
}

export interface DispatchProps {
  setParams: (payload: PartialSearchingProps) => SetFamilyListParamsAction;
}

export interface Props extends StateProps, DispatchProps {
  onDeleteClick?: (family: Family) => void;
}

export const mapState = (state: RootState): StateProps => {
  const { families, sort } = state.family.list;

  return { families, sort };
};

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setFamilyListParamsAction(payload))
});

export class FamilyTable extends React.Component<Props> {
  readonly cols: TableCol<Family>[];
  readonly deleteModalRef: React.RefObject<DeleteFamilyModalClass>;

  constructor(props: Props) {
    super(props);

    this.deleteModalRef = createRef();

    this.cols = [
      {
        property: 'genus',
        label: 'Genus',
        className: 'col-11',
        sortable: true,
        columnRedirectTo: (row) =>
          getPathUrl(ROUTE_FAMILY_DETAILS, { id: row.id })
      },
      {
        property: 'is_deleted',
        label: 'Is deleted',
        value: (row) => row.getIsDeleted(),
        className: 'col-1'
      },
      {
        property: null,
        label: 'Action',
        value: (row) => (
          <div className="actions-wrapper">
            <ActionShow
              title="Show family"
              to={getPathUrl(ROUTE_FAMILY_DETAILS, {
                id: row.id,
                type: 'main'
              })}
            />
            <ActionUpdate
              title="Edit family"
              disabled={Boolean(row.is_deleted)}
              to={getPathUrl(ROUTE_FAMILY_DETAILS_FORM, {
                id: row.id,
                type: 'main'
              })}
            />
            <ActionDelete
              title="Delete family"
              disabled={Boolean(row.is_deleted)}
              onClick={() => this.deleteModalRef?.current?.openModal(row)}
            />
          </div>
        )
      }
    ];
  }

  render(): ReactNode {
    const { families, sort, setParams } = this.props;

    return (
      <>
        <DeleteFamilyModal
          ref={this.deleteModalRef}
          onSuccess={() => setParams({ sort })}
        />
        <Table
          cols={this.cols}
          rows={families}
          sort={sort}
          onSort={(params) => setParams({ sort: params })}
        />
      </>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(FamilyTable);
